import { CopyAll } from "@mui/icons-material";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { COLORS } from "assets";
import { useCallback } from "react";

interface ITokenShow {
  token?: string;
  light?: boolean;
}

export default function TokenShow({ token, light }: ITokenShow) {
  const onCopy = useCallback(() => {
    if (token) {
      navigator.clipboard.writeText(token);
    }
  }, [token]);

  return (
    <Box display="inline-flex" alignItems="center" gap={0.5}>
      <Typography
        component="span"
        variant="body2"
        sx={{ color: light ? COLORS.surface.primaryText : undefined, letterSpacing: 1 }}
      >
        ***********
      </Typography>
      <Tooltip title="Copy">
        <IconButton
          size="small"
          onClick={onCopy}
          sx={{ color: light ? COLORS.surface.secondaryText : undefined }}
        >
          <CopyAll fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
